<template>
	<section class="wrapper">
		<div style="padding: 20px;">
			<div class="top_div">
				<i @click="$router.back()" class="iconfont icon24px icon-circle-left" style="color: #333;"></i>
				<h2>{{$t('title_text.Look_Task_title')}}</h2>
			</div>
			<div class="bottom_div">
				<el-form :inline="true" :model="state.task_query_from" class="demo-form-inline">
					<el-form-item label="任务名称">
						<el-input v-model="state.task_query_from.task_name" placeholder="请输入任务名称" clearable />
					</el-form-item>
					<el-form-item label="任务ID">
						<el-input v-model="state.task_query_from.task_id" placeholder="请输入任务ID" clearable />
					</el-form-item>
					<el-form-item label="执行状态">
						<el-select v-model="state.task_query_from.execute_state" style="width: 240px"
							placeholder="请输入执行状态" clearable>
							<el-option label="Zone one" value="shanghai" />
							<el-option label="Zone two" value="beijing" />
						</el-select>
					</el-form-item>
					<el-form-item label="任务类型">
						<el-select v-model="state.task_query_from.task_type" style="width: 240px" placeholder="请输入任务类型"
							clearable>
							<el-option label="Zone one" value="shanghai" />
							<el-option label="Zone two" value="beijing" />
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit" icon="Search">查询</el-button>
					</el-form-item>
				</el-form>
				<el-table :data="state.tableData" style="width: 100%" :header-cell-style="{ textAlign: 'center',backgroundColor: '#fafafa',color:'#333'}"  :cell-style="{ textAlign: 'center'}">
					<el-table-column prop="date" label="任务名称" width="180" />
					<el-table-column prop="name" label="任务ID" width="180" />
					<el-table-column prop="date" label="任务类型" width="180" />
					<el-table-column prop="name" label="任务状态" width="180">
						<template #default="scope">
							<el-tag>{{ scope.row.name }}</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="name" label="任务执行时间" width="180" />
					<el-table-column prop="name" label="任务创建时间" width="180" />
					<el-table-column prop="name" label="失败原因" width="180" />
					<el-table-column fixed="right" label="Operations" min-width="120">
						<template #default>
							<el-button link type="primary" size="small" @click="handleClick">启动</el-button>
							<el-button link type="primary" size="small">强制停止</el-button>
							<el-button link type="primary" size="small">查看</el-button>
							<el-button link type="primary" size="small">编辑</el-button>
							<el-button link type="primary" size="small">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
	</section>
</template>

<script setup>
	import {
		ref,
		reactive,
		computed,
		onMounted,
		onUnmounted,
		getCurrentInstance,
		watch,
	} from 'vue';
	import request from '@/utils'
	import {
		ElMessage,
		ElMessageBox,
		ElLoading,
		ElIcon
	} from 'element-plus';
	import {
		useStore
	} from 'vuex';
	const store = useStore();
	const state = reactive({
		task_query_from: {
			task_name: '',
			task_id: '',
			execute_state: '',
			task_type: ''
		},
		tableData: [{
				date: '2016-05-03',
				name: 'Tom',
				address: 'No. 189, Grove St, Los Angeles',
			},
			{
				date: '2016-05-02',
				name: 'Tom',
				address: 'No. 189, Grove St, Los Angeles',
			},
			{
				date: '2016-05-04',
				name: 'Tom',
				address: 'No. 189, Grove St, Los Angeles',
			},
			{
				date: '2016-05-01',
				name: 'Tom',
				address: 'No. 189, Grove St, Los Angeles',
			},
		]
	})

</script>

<style lang="less" scoped>
	h2 {
		margin: 0;
		margin-left: 10px;
	}

	.wrapper {
		background-color: #fff;
		border-radius: 10px;
		position: relative;

		.top_div {
			display: flex;
			align-items: center;
			padding-top: 10px;
			padding-bottom: 20px;
			padding-left: 10px;
			border-bottom: 1px solid #ececec;

			i {
				cursor: pointer;
			}
		}

		.bottom_div {
			margin-top: 20px;
			text-align: left;
		}
	}
	
</style>